import { autoinject } from 'aurelia-framework';
import { ValidationController } from 'aurelia-validation';
import { DialogHelper } from 'framework/aurelia_dialogs/dialog-helper';
import { VALIDATION_MESSAGES_LIMIT } from './settings';

@autoinject
export class ValidationHelper {
  constructor(private dialogHelper: DialogHelper) { }

  async validate(controller: ValidationController) {
    const result = await controller.validate();
    if (!result.valid) {
      const messages = result.results.filter(r => !r.valid).map(r => r.message).filter((v, i, s) => s.indexOf(v) === i);
      const firstfew = messages.slice(0, VALIDATION_MESSAGES_LIMIT);
      this.dialogHelper.alert({
        dialogTitle: 'Form validation failed',
        okTitle: 'Okay, let me fix that...',
        message: 'Some mandatory items or fields have been left out or their value is invalid.\nPlease fix the following issues and try again:',
        details: firstfew.length < messages.length ? [...firstfew, 'and more...'] : firstfew,
        class: '--warning',
        icon: 'fas fa-hand-paper'
      });
    }
    return result.valid;
  }
}
